import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios';
import './chat.css';
import DateTimeManager from './../Common/DateTimeManager';
import SignalRController from '../SignalRController.js';
import ChatContext from './../context/ChatContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';

export class SendToPopup extends React.Component {
    constructor(props) {

        super(props);
        this.superAdminRoleId = 1;
        this.moderatorRoleId = 2;
        this.meetingAdminRoleId = 4;
        this.moderatorAdminRoleId = 5;
        this.presenterRoleId = 3;
        this.ChatResponseUser = 1;
        this.ChatResponseInternal = 2;
        this.ButtonClick = "";
        this.state = {
            modal: true,
            Comment: this.props.chat.messageNotes,
            activeChat: this.props.chat,
            commentError: '',
            messageSent: ''
        };

        this.onClosed = this.onClosed.bind(this);
        this.close = this.close.bind(this);
        this.SendToInboxOnClick = this.SendToInboxOnClick.bind(this);
        this.SendOnClick = this.SendOnClick.bind(this);
        this.commentUpdate = this.commentUpdate.bind(this);
    }

    onClosed() {
        this.props.onClosed && this.props.onClosed();
        this.props.closeMethod && this.props.closeMethod();
    }

    close() {
        this.props.toggle();
    }

    commentUpdate = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
        this.setState({ Comment: object.target.value });
    }

    async SendToInboxOnClick(inbox) {
        this.state.Comment !== '' && await this.SendOnClick(this.props.chat);
        axios.get(`api/AddChatToInbox`, { params: { vmId: this.props.VMeetingId, chatId: this.props.chat.messageId, inbox: inbox } }).then(res => {
            this.close();
        })
    }

    async SendOnClick() {
        var chatResponse = {
            VMeetingId: this.props.VMeetingId,
            MessageId: this.props.chat.messageId,
            SubmittedById: this.props.chat.attendeeId,
            QuestionText: this.state.Comment,
            AdminId: 999
        };
        var dataChatResponse;
        if (this.state.Comment !== '') {
            axios.post(`api/UpdateMessageNotes`, chatResponse).then(res => {
                dataChatResponse = res.data;
                if (dataChatResponse !== null && dataChatResponse !== "") {
                    this.setState({
                        adminChatResponses: dataChatResponse
                    });
                }
            }).catch(err => {
                console.log("error", "sending chat response");
            });
        }
    }


    render() {
        let chat = this.props.chat;
        return (
            <React.Fragment>
                <Modal isOpen={this.state.modal} className="custom-modal-style" toggle={this.props.toggle} onClosed={this.onClosed}>
                    <ModalHeader className="messaging-modal-header">
                        <span className="chat-heading">Send to chat box
                            <button className="btn closeBoxSendTo" onClick={() => { this.close() }}>&times;</button></span>
                    </ModalHeader>
                    <ModalBody>
                        <span>

                            <div className="chat-box-pres">

                                <div key={chat.messageId + '_' + chat.responseId} className="grid-container-pres" >
                                    <div className="Status" onClick={this.props.respond ? () => this.props.respond(chat) : null}>{chat.messageId}</div>
                                    <div className="Title-Bar" onClick={this.props.respond ? () => this.props.respond(chat) : null}>
                                        {chat.attendeeName ? chat.attendeeName : <span>User ID: {chat.attendeeId}</span>}
                                    </div>
                                    <div className="MessageForward" onClick={this.props.respond ? () => this.props.respond(chat) : null}>{chat.messageText}</div>
                                    <div className="Time" onClick={this.props.respond ? () => this.props.respond(chat) : null}> {new DateTimeManager(chat.messageDateTime).getTimeDefaultFormat()} </div>
                                </div>
                            </div>
                        </span>
                    </ModalBody>
                    <div className="Pchat-tiles">
                        <div className="row no-gutters">
                            <div className="input-group">
                                <textarea id="comment" name="comment" maxLength="500" onInput={this.commentUpdate} className="form-control type_msg" onChange={this.commentUpdate} placeholder="Type a note to tag to this message" value={this.state.Comment}></textarea>
                            </div>
                        </div>
                    </div>
                    <ModalFooter className="messaging-modal-footer">
                        <div className="row no-gutters">
                            {
                                this.props.isAuthorized
                                &&
                                <div className="chat-tiles-reply">Send To <span className="pinkIcon"><FontAwesomeIcon icon={faAngleDoubleRight} /></span>
                                        <button 
                                            className="btn btn-sm btn-virtual-meeting"
                                            onClick={() => { this.SendToInboxOnClick(2); }}>
                                            Moderator
                                        </button>
                                        <button 
                                            className="btn btn-sm btn-virtual-meeting"
                                            onClick={() => { this.SendToInboxOnClick(4); }}>
                                            Presenter
                                        </button>
                                        <button                                       
                                            className="btn btn-sm btn-virtual-meeting"
                                            onClick={() => { this.SendToInboxOnClick(8); }}>
                                            Tech Support
                                        </button>
                                </div>

                                //:<div className="chat-tiles-reply">Send To <span className="pinkIcon"><FontAwesomeIcon icon={faAngleDoubleRight} /></span>
                                //  <button className="btn btn-sm btn-virtual-meeting" onClick={() => { this.SendToInboxOnClick(1); }}>Moderator Admin</button>
                                //</div>
                            }
                        </div>
                    </ModalFooter>
                </Modal>
            </React.Fragment>);
    }
}

SendToPopup.defaultProps = {
    onClosed: (e) => { }
}

SendToPopup.contextType = ChatContext;

export default SendToPopup;




